(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('social-media', {
            parent: 'entity',
            url: '/social-media',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.socialMedia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/social-media/social-medias.html',
                    controller: 'SocialMediaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('socialMedia');
                    $translatePartialLoader.addPart('socialMediaType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('social-media-detail', {
            parent: 'social-media',
            url: '/social-media/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.socialMedia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/social-media/social-media-detail.html',
                    controller: 'SocialMediaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('socialMedia');
                    $translatePartialLoader.addPart('socialMediaType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SocialMedia', function($stateParams, SocialMedia) {
                    return SocialMedia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'social-media',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('social-media-detail.edit', {
            parent: 'social-media-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/social-media/social-media-dialog.html',
                    controller: 'SocialMediaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SocialMedia', function(SocialMedia) {
                            return SocialMedia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('social-media.new', {
            parent: 'social-media',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/social-media/social-media-dialog.html',
                    controller: 'SocialMediaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                socialMediaType: null,
                                link: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('social-media', null, { reload: 'social-media' });
                }, function() {
                    $state.go('social-media');
                });
            }]
        })
        .state('social-media.edit', {
            parent: 'social-media',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/social-media/social-media-dialog.html',
                    controller: 'SocialMediaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SocialMedia', function(SocialMedia) {
                            return SocialMedia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('social-media', null, { reload: 'social-media' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('social-media.delete', {
            parent: 'social-media',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/social-media/social-media-delete-dialog.html',
                    controller: 'SocialMediaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SocialMedia', function(SocialMedia) {
                            return SocialMedia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('social-media', null, { reload: 'social-media' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
